import React from 'react';
import StatusWithDraftAndActive from '../../../../model/StatusWithDraftAndActive';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const StatusWithDraftAndActiveMultiSelector = ({ title, ...props }) => {
    const { options } = useEnumerableModel(StatusWithDraftAndActive);
    const _title = useLabel('Status', title);
    return (<MultiselectFilter itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default StatusWithDraftAndActiveMultiSelector;
